jQuery.noConflict();
(function( $ ) {
    $(function() {
    //Document Ready STARTS

        var wdata = [];
        wdata.mobileWidth = 640;
        wdata.swiper = [];
        wdata.debug = false;

        //PLACEHOLDERS
        $('input, textarea').placeholder(); //add placeholders for load browsers

        function afterLoad() {
            svgSupport();
            updateWData();
            runSwiper();
            lazyBg();
            removeSplash();
            bindClick();
            $('.mobile-nav').attr('style', '');
            if ($('body').hasClass('page-id-45')) {
                $('body').addClass('cta-top');
            }
        }

        afterLoad();

        // Functions On Window resize
        $(window).on('resize', function(){
            updateWData();
            lazyBg();
            layoutBlockVis();
        });

        // Window scroll
         $(window).on('scroll', function(){
            wdata.scrollTop = $(window).scrollTop();
            lazyBg();
            layoutBlockVis();

             if ($('.cta-block').length> 0) {
                 console.log(wdata.scrollTop);
                 if (wdata.scrollTop > (wdata.wh * 0.8)) {
                     $('body').addClass('cta-in');
                     $('body').removeClass('cta-top');
                 }
                 else if ($('body').hasClass('home')) {
                     $('body').addClass('cta-top');
                 }
                 else {
                     $('body').removeClass('cta-in');
                     $('body').removeClass('cta-top');
                 }
             }
        });

        // mobile menu toggle functions
        $('.hamburger').on('click', function(e){
            e.preventDefault();
            $(this).toggleClass('is-active');
            $('.mobile-nav').toggleClass('active');
            $('body').toggleClass('scroll-lock').toggleClass('mobile-menu');
        });

        $('.close-menu').on('click', function(e){
            $('.hamburger').trigger('click');
        });

        //Adjust Header spacer height
        function spacerHeight() {
            $('.header-spacer').attr('style', '');
            var headerHeight = $('.header').outerHeight();
            $('.header-spacer').height(headerHeight);
        }

        $('body').on('click', '.service-preselect', function(e){
            e.preventDefault();
            var service = $(this).attr('data-service');
            if (service != undefined && service != '') {
                var off = $(this).offset();
                $('.services-pop select[name=your-service]').val(service).trigger('change');
                $('body').addClass('pop-open');
                if (wdata.ww > wdata.mobileWidth) {
                    if ((wdata.ww/2) > off.left) {
                        var leftPos = off.left + 200;
                        $('#services-pop').attr('style', 'left: '+leftPos+'px; top: '+off.top+'px;');
                    }
                    else {
                        var leftPos = off.left - 480;
                        $('#services-pop').attr('style', 'left: '+leftPos+'px; top: '+off.top+'px;');
                    }
                }
                else {
                    var newTop = off.top + $(this).outerHeight(),
                        width = $(this).outerWidth();
                    $('#services-pop').attr('style', 'left: '+off.left+'px; top: '+newTop+'px; width: '+width+'px;');
                }
                $('#services-pop').addClass('animate-in');
                setTimeout(function(){
                    $('#services-pop').removeClass('animate-in');
                }, 500);
            }
        });

        $('body').on('click', '.services-pop-overlay', function(){
            $('body').removeClass('pop-open');
            $('#services-pop').hide();
        });

        //Check if DOM has MAP
        if(($('#map').data('lat') != '') && ($('#map').data('lat') != undefined)) {
            initMap();
        }

        function removeSplash() {
            $( '.splishs-plash-splosh').fadeTo( 'fast' , 0.1, function() {
                $( '.splishs-plash-splosh').remove();
                layoutBlockVis();
            });
        }

        /* Run sliders */
        function runSwiper() {
            var centerSlides = false;
            var starSlide = 0;
            if (wdata.ww < wdata.mobileWidth) {
                centerSlides = true;
                starSlide = 1;
            }

            $.each($('.sw-wrap .swiper-container'), function(e){
                var sliderId = $(this).attr('id'),
                    rowId = $(this).attr('data-id');
                //  console.log(sliderId +'ss');
                if (sliderId != undefined && sliderId != '') {
                    wdata.swiper[sliderId] = new Swiper('#'+sliderId, {
                        slidesPerView: 'auto',
                        centeredSlides: centerSlides,
                        initialSlide: starSlide,
                        spaceBetween: 0,
                        navigation: {
                            nextEl: '.next-'+rowId,
                            prevEl: '.prev-'+rowId,
                        },
                        keyboard: {
                            enabled: true,
                            onlyInViewport: true,
                        },
                    });
                }
            });

            if ($('.logos-slider').length>0) {
                var logosSlider = new Swiper('.logos-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    speed: 800,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        clickable: true,
                    },
                });
            }

            if ($('.clients-slider').length>0) {
                var clientsSlider = new Swiper('.clients-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    speed: 900,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        clickable: true,
                        el: ".swiper-pagination",
                    },
                    on: {
                        slideChangeTransitionStart: function(e){
                            $('.client-feedback').addClass('transition');
                        },
                        slideChangeTransitionEnd: function(e) {
                            clientFeedback(e.realIndex, e.loopedSlides);
                        }
                    },
                });
            }

            function clientFeedback(num, max){
                if (num != undefined) {
                    var data_name = $('.clients-slider').attr('data-feedback');
                    if (data_name != undefined && data_name != '' && window[data_name] != undefined) {
                        var index = num+1;
                        if (index >= max) {
                            index = 0;
                        }
                        var data = window[data_name],
                            client = data[index];
                        if (client != undefined) {
                            var html = '<div class="c-feedback-quote"><blockquote>'+client['quote']+'</blockquote></div>';
                            html += '<div class="c-feedback-by">'+client['author']+'<p class="conpany-name">'+client['company']+'</p></div>';
                            $('.client-feedback').html(html);
                        }
                        setTimeout(function(){
                            $('.client-feedback').removeClass('transition');
                        }, 100);
                    }
                }
            }

            if ($('.images-slider').length>0) {
                var imagesSlider = new Swiper('.images-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    speed: 800,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true,
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        clickable: true,
                    },
                });
            }
        }

        // Location lookup
        function showAvailabilityTable(postcode, lat, lng) {
            $('.fcl_availability_check .loading-outer').removeClass('hide').hide().fadeIn(200);
            var postData = { action: 'check_availability', postcode: postcode, lat: lat, lng: lng };
            $.post( ajax_url, postData, function(data) {
                $('.fcl_availability_check .loading-outer').hide();
                if ( data.indexOf('speed') < 0 && data.indexOf('results-table') < 0 ) {
                    var statusText = 'Sorry, it looks like we aren\'t in your area yet. Sign up to our newsletter and '
                        + 'be the first to know when we land!';
                    $('.fcl_availability_check .results').html('<h2 class="no-results">' + statusText + '</h2>');
                    return false;
                }

                if ( data.indexOf('results-table') >= 0 ) {
                    $('.fcl_availability_check .results').html( '<div class="net-results">' +  data + '</div>' );
                    return true;
                }

                results = $.parseJSON(data);

                var html = '<table class="table has-labels"><thead><tr><th>Price Per Month</th><th>Speed (Mbps)</th><th>Bearer (Mbps)</th>'
                    + '<th>&nbsp;</th></tr></thead><tbody>';
                for (var i=0; i < results.length; i++) {
                    var perMonth = '£' + ( results[i].price_annual / 12 ).toFixed(2);
                    html += '<tr data-id="' + results[i].uuid + '"><td class="month" data-label="Price Per Month">' + perMonth
                        + '</td><td class="speed" data-label="Speed (Mbps)">' + results[i].speed
                        + '</td><td class="bearer" data-label="Bearer (Mbps)">' + results[i].bearer + '</td>'
                        + '<td class="text-right"><a href="#" class="button small">Choose</a></td></tr>';
                }
                html += '</tbody></table><p class="callout success text-center"><strong>All orders will be subject to survey.</strong></p>';
                $('.fcl_availability_check .results').html(html);
            });
        }

        $('.fcl_availability_check .lookup .button').click(function() {
            if ( $('.fcl_availability_check .lookup select.address').is(':visible') ) {
                if ( $('.fcl_availability_check .lookup select.address').val().indexOf(':') >= 0 ) {
                    var parts = $('.fcl_availability_check .lookup select.address').val().split(':');
                    if (parts.length != 3) {
                        return false;
                    }
                    showAvailabilityTable( parts[0], parts[1], parts[2] );
                }
                return false;
            }

            var postcode = $('.fcl_availability_check .lookup input.postcode').val();
            if (postcode.length < 1) {
                alert('Please enter a Postcode.');
                return false;
            }

            // Automatically add space
            if ( postcode.indexOf(' ') < 0 ) {
                postcode = postcode.substring( 0, postcode.length - 3 ) + ' ' + postcode.substring( postcode.length - 3 );
            }

            // Now uses address lookup
            var postData = { action: 'lookup_address', query: postcode };
            $.post( ajax_url, postData, function(data) {

                if ( data.indexOf('address') < 0 ) {
                    alert('Postcode not found, please try again.');
                    return false;
                }

                var results = $.parseJSON(data);
                if (results.length < 1) {
                    alert('Postcode not found, please try again.');
                    return false;
                }

                var html = '<option value="">Choose your address...</option>';
                for ( var i=0; i < results.length; i++ ) {
                    var key = results[i].postcode + ':' + results[i].lat + ':' + results[i].lng;
                    html += '<option value="' + key + '">' + results[i].address + '</option>';
                }

                $('.fcl_availability_check .lookup input.postcode').fadeOut(250);
                setTimeout(function() {
                    $('.fcl_availability_check .lookup select.address').html(html).removeClass('hide').hide().fadeIn(250);
                }, 250);

            });

        });
        $('.fcl_availability_check .lookup').keyup(function(e) {
            if ( e.keyCode == 13 ) {
                $('.fcl_availability_check .lookup .button').click();
            }
        });
        if ( $('.fcl_availability_check .lookup input[name=postcode]').val() != '' ) {
            $('.fcl_availability_check .lookup .button').click();
        }
        $('.fcl_availability_check').on('click', '.results .table .button', function(e) {
            e.preventDefault();

            $('.fcl_availability_check').find('.results .table .button').removeClass('cta');
            $(this).addClass('cta');

            var $row = $(this).closest('tr'),
                address = $('.fcl_availability_check .lookup select.address').find('option:selected').text();
            if ( $('.net-results').length === 0 ) {
                var chosen = 'Chosen Address: ' + address + "\nUUID: " + $row.data('id')
                    + " \nPrice Per Month: " + $row.find('.month').text() + " \nSpeed (Mbps): "
                    + $row.find('.speed').text() + " \nBearer (Mbps): " + $row.find('.bearer').text();
            } else {
                var chosen = 'Chosen Address: ' + address + "\nNET Choice: " + $(this).data('product');
            }

            $('.availability-form.hide').removeClass('hide').hide().fadeIn(200);
            $('.availability-form').find('input[name=chosen-option]').val(chosen);

            var hash = '#' + $('.availability-form').attr('id');
            scrollToEl(hash, 220);

            return false;
        });

        // Saving calculator AJAX action
        $('.fcl_savings_calculator .black-box form .button').click(function() {
            $('.fcl_savings_calculator .black-box form input').each(function() {
                if ( $(this).val() < 0.01 ) {
                    $(this).addClass('error');
                } else {
                    $(this).removeClass('error');
                }
            });
            if ( $('.fcl_savings_calculator .black-box form input.error').length > 0 ) {
                return false;
            }

            var postData = { action: 'calculate_savings' };
            $('.fcl_savings_calculator .black-box form input, .fcl_savings_calculator .black-box form select').each(function() {
                var name = $(this).attr('name');
                postData[name] = $(this).val();
            });

            $.post( ajax_url, postData, function(data) {
                if ( data.indexOf('overall') < 0 ) {
                    alert('Error, please try again.');
                    return false;
                }

                var savings = $.parseJSON(data);
                $('.overall-savings .overall .value').text( savings.overall );
                $('.overall-savings .average .value').text( savings.hours );
                $('.overall-savings .accross .value').text( postData.savings_employees );
                $('.overall-savings .accross .value2').text( savings.day );
                $('.overall-savings .accross .value3').text( savings.week );
                $('.overall-savings .accross .value4').text( savings.year );
                $('.overall-savings .equate .value').text( postData.savings_salary );
                $('.overall-savings .equate .value2').text( savings.overall );
                $('footer.footer .the-number').html('<span class="num" title="04">04</span>');
                console.log(savings);
                $('.overall-savings-outer').removeClass('hide').hide().fadeIn(500);
                scrollToEl('#overall-savings', 220);
            });
        });

        $('.fcl_savings_calculator .number').each(function() {
            $(this).append('<span class="change-q up"></span><span class="change-q down"></span>');
        });
        $('.fcl_savings_calculator .number').on('click', '.change-q', function() {
            var $field = $(this).parent().find('input[type=number]'),
                current = $field.val() * 1,
                step = $field.attr('step') * 1 || 1,
                min = $field.attr('min') * 1 || 1,
                max = $field.attr('max') * 1 || 9999;

            if ( $(this).hasClass('up') ) {
                var newVal = current + step;
                if (newVal > max && max != '') {
                    newVal = max;
                } else if (newVal < min) {
                    newVal = min;
                }
            } else {
                var newVal = current - step;
                if (newVal < min  && min != '') {
                    newVal = min;
                }
            }
            $field.val( newVal.toFixed(1) * 1 );
        });


        //init MAP with custom settings
        function initMap() {

            var $mapDiv = $('#map'),
                lat = $mapDiv.data('lat'),
                lan = $mapDiv.data('lan'),
                zoom = $mapDiv.data('zoom'),
                markerImg = $mapDiv.data('marker'),
                title = $mapDiv.data('title'),
                windowHeight = $( window ).height(),
                mapHeight =  (windowHeight/2) - 150;

            //set map height to half window height
            if (mapHeight<400) {
                mapHeight = 400;
            }

            $mapDiv.height(mapHeight);

            var optionNavigationControl = false,
                optionTypeControl = true,
                optionScaleControl = true,
                optionDraggable = true,
                optionScrollwheel = false;
            if($('body').hasClass('mobile')) {
                    optionNavigationControl = false;
                    optionTypeControl = false;
                    optionScaleControl = false;
                    optionDraggable = false;
                    optionScrollwheel = false;
            }

            var myLatLng = {lat: lat, lng: lan};
            var map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoom,
                // mapTypeId: google.maps.MapTypeId.SATELLITE,
                navigationControl: optionNavigationControl,
                mapTypeControl: optionTypeControl,
                scaleControl: optionScaleControl,
                draggable: optionDraggable,
                scrollwheel: optionScrollwheel,
                center: myLatLng
            });

            var markerImage = new google.maps.MarkerImage(markerImg,
                new google.maps.Size(41, 61), //size
                new google.maps.Point(0, 0), //origin point
                new google.maps.Point(20, 61)); // offset point

            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                icon: markerImage,
                title: title
            });
        }

                if ($('#open-map').length>0) {
            initOpenStreetMap();
        }

        function initOpenStreetMap(){
            var mapHeight = getWindowHeight() * 0.4;
            if (mapHeight < 400) {
                mapHeight = 400;
            }

            $('#open-map').css( 'height', mapHeight);
            map = L.map('open-map').setView([omap.center_lat, omap.center_lng], omap.zoom);

            // add an OpenStreetMap tile layer
            var tile = L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
            });
            tile.addTo(map);
            addOpenMarkers();
        }

        function addOpenMarkers() {
            var markers = omap.markers;
            var imgUrl = $('#open-map').attr('data-marker');
            var mapIcons = [];
            mapIcons.st = L.icon({
                iconUrl: imgUrl,
                iconSize: [30, 50]
            });
/*            mapIcons['w'] = L.icon({
                iconUrl: imgUrl + 'status-s-w.png',
                iconSize: [20, 20]
            });
            mapIcons['wr'] = L.icon({
                iconUrl: imgUrl + 'status-s-wr.png',
                iconSize: [20, 20]
            });*/

            for (var i=0; i < markers.length; i++) {
                var lat = markers[i].lat,
                    lng = markers[i].lng,
                    markerTitle = markers[i].default_label;
                L.marker([ lat, lng ], {title: markerTitle, icon: mapIcons.st }).addTo(map);
            }
        }

        //click trigger
        function bindClick() {
            $('.clickTrigger').on('click', function(e) {
                e.preventDefault();
                var targetLine = $(this).data('target');
                var $target = $( targetLine);
                $target.trigger( "click" );

            });
        }

        //Scroll to el if page has Hash
        if(window.location.hash) {
            var hash = window.location.hash;
            if ($(hash).length>0) {
                scrollToEl(hash, 220);
            }
        }

        //function scroll to element
        function scrollToEl(target, offset) {
            if ($(target).length> 0) {
                var $target = $(target);
                $("html, body").animate({ scrollTop: $target.offset().top - (offset + 70)}, 1000);
            }
        }

        function updateWData() {
            wdata.ww = getWindowWidth();
            wdata.wh = getWindowHeight();
            wdata.scroll =  $(window).scrollTop();

            if (wdata.debug == true) {
                console.info('updateWData');
                console.log(wdata);
            }
        }

        setTimeout(function(){
            $('div,ul,li,a,label,iframe').removeAttr('role');
            $('.swiper-slide').removeAttr('aria-label');
        }, 3000);

        function lazyBg(){
            var TopPos = $(window).scrollTop(),
                BottomPos = TopPos + $(window).height();
            var use = 'src';
            if (wdata.ww > 1200) {
                use = 'large';
            }
            $.each($('.lazy-bg.blur'), function() {
                var TopElement = $(this).offset().top,
                    BotElement = TopElement + $(this).height(),
                    diff = $(this).height() * 0.6;
                TopElement = diff + TopElement;
                BotElement = BotElement - diff;
                if ((BotElement <= BottomPos) && (TopElement >= TopPos)) {
                    var imgSrc = $(this).attr('data-'+use),
                        hash = $(this).attr('data-hash');
                    loadImage(imgSrc, hash).then(function(img){
                        $('.lazy-bg[data-hash='+hash+']').attr('style', 'background-image: url('+imgSrc+');').removeClass('blur').addClass(use);
                    });
                }
            });
        }

        function layoutBlockVis(){
            $.each($('.fc-row'), function() {
                var id = $(this).attr('id');
                if (isInViewPort('#'+id)) {
                    $('#'+id).removeClass('non-visible').addClass('is-visible');
                }
                else {
                    $('#'+id).addClass('non-visible').removeClass('is-visible');
                }
            });

            $.each($('.track-visibility'), function() {
                var id = $(this).attr('id');
                if (isInViewPort('#'+id)) {
                    $('#'+id).removeClass('non-visible').addClass('is-visible');
                }
                else {
                    $('#'+id).addClass('non-visible').removeClass('is-visible');
                }
            });


            if ($('.fc-row.last-row').maxLength> 0) {
                if (isInViewPort('.fc-row.last-row')) {
                    $('footer.footer').removeClass('non-visible').addClass('is-visible');
                }
                else {
                    $('footer.footer').addClass('non-visible').removeClass('is-visible');
                }
            }
        }

        //check if element is visible #element, .element
        function isElementVisible(elementToBeChecked) {
            var TopView = $(window).scrollTop();
            var BotView = TopView + $(window).height();
            var TopElement = $(elementToBeChecked).offset().top;
            var BotElement = TopElement + $(elementToBeChecked).height();
            return ((BotElement <= BotView) && (TopElement >= TopView));
        }

        function blockPositionsData(elementToBeChecked) {
            var TopView = $(window).scrollTop(),
                BotView = TopView + $(window).height(),
                TopElement = $(elementToBeChecked).offset().top,
                BotElement = TopElement + $(elementToBeChecked).height(),
                elementHeight = $(elementToBeChecked).height();
            var data = [];
            data.top = TopView;
            data.bottom = BotView;
            data.height = elementHeight;
            data.posTop = TopElement;
            data.posBottom = BotElement;
            return data;
        }

        function isInViewPort(elementToBeChecked) {
            var TopView = $(window).scrollTop();
            var BotView = TopView + $(window).height();
            var TopElement = $(elementToBeChecked).offset().top;
            var BotElement = TopElement + $(elementToBeChecked).height();
            var elementHeight = $(elementToBeChecked).height();
            var status = false;
            if ((TopView - elementHeight) < TopElement && BotView > (BotElement - elementHeight)) {
                status = true;
            }
            return status;
        }

        function svgSupport() {
            if (typeof SVGRect != "undefined") {
                $('body').addClass('svg');
                var status = true;
                $.each($('img[data-svg]'), function(){
                    var svg = $(this).attr('data-svg'),
                        width = $(this).width(),
                        height = $(this).height();
                    if (svg != undefined && svg != '') {
                        $(this).attr('src', svg);
                    }
                });
            }
            else {
                $('body').addClass('no-svg');
                var status = false;
            }
            if (window.devicePixelRatio > 1.3) {
                $('body').addClass('retina');
            }
            return status;
        }

        if ($('.sc_cookie_notification').length>0) {
            // Show cookie notification
            var notificarionContainer = $('.sc_cookie_notification'),
                siteHash = notificarionContainer.attr('data-cname'),
                timestamp = Date.now(),
                acceptCheck = localStorage.getItem(siteHash);
            if (acceptCheck == null || acceptCheck == undefined || acceptCheck < timestamp) {
                setTimeout(function(){
                    notificarionContainer.slideToggle();
                }, 2000);
            }
            // Hide
            // cookie notification
            $('.sc_accept_cookie').on('click', function(){
                var notificarionContainer = $('.sc_cookie_notification'),
                    siteHash = notificarionContainer.attr('data-cname'),
                    expireDays = notificarionContainer.attr('data-expires'),
                    timestamp = Date.now(),
                    dayInMiliseconds = 86400000,
                    expires = (expireDays * dayInMiliseconds) + timestamp;
                localStorage.setItem(siteHash, expires);
                notificarionContainer.slideToggle();
                setTimeout(function(){
                    notificarionContainer.remove();
                }, 500);
            });
        }

    //Document Ready ENDS
    });
})(jQuery);

/* Array to JSON */
function encodeJSON(fields) {
    var jsonLine = JSON.stringify(fields);
    return jsonLine;
}

/* JSON to array */
function decodeJSON(string) {
    var array = jQuery.parseJSON(string);
    return array;
}

function searchParams(url) {
    if (url == undefined) {
        url = window.location.href;
    }
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
}

//window height
function getWindowHeight() {
    return jQuery( window ).height();
}

//window width
function getWindowWidth() {
    return jQuery( window ).width();
}

//validate Phone
function validatePhone(phone) {
    var re = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    return re.test(phone);
}

//validate Email
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function loadImage(imgSrc, hash) {
    return new Promise( function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            resolve(img);
        };
        img.onerror = function() {
            reject(img);
        };
        img.src = imgSrc;
    })
}
